var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery"},[(_vm.getMatchedImages.length > 0)?_c('galleryComponent'):_vm._e(),_vm._v(" "),(_vm.getMatchedImages.length === 0)?_c('div',{staticClass:"no-matches-found"},[_c('h1',[_vm._v("No matches found!")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-783a4772","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/gallery.vue
// module id = gMT6
// module chunks = 1